import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/apiservices'

class PEAgentsComboList extends Component {
    constructor() {
        super()
        this.state = {
            pEAgentsComboList: {}
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        
       
        this.getPEAgentsCombolList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }


    getPEAgentsCombolList = () => {
        apiService.getPEAgentsCombolList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        pEAgentsComboList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.pEAgentsComboList).map((value,index) => {
            
            return {
                label : this.state.pEAgentsComboList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Agent"
                options={list}
                onChange={(e) => { (e) ? this.props.agentChange(e) : this.props.agentChange([])}}
                />
            </div>
        )
    }
}
export default PEAgentsComboList


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/DropDowns/PEAgentsComboList.js